import { cn } from '@/platform/lib/utils';
import TableBody from './TableBody';
import TableCell from './TableCell';
import TableFooter from './TableFooter';
import TableHeader from './TableHeader';
import TableHeaderCell from './TableHeaderCell';
import TableRow from './TableRow';

const Table = ({ striped = false, className, children, ...props }) => (
    <div className='w-full overflow-x-auto rounded-lg border border-gray-200 bg-white'>
        <table
            className={cn(
                'w-full table-auto border-collapse text-left text-[0.8125rem] leading-5 text-gray-700',
                striped &&
                    '[&_tbody_tr:nth-child(even):not([data-error])]:bg-gray-50/70',
                '[&_tbody_tr:not([data-error]):hover>*]:bg-primary-50',
                className
            )}
            {...props}
        >
            {children}
        </table>
    </div>
);

Table.Header = TableHeader;
Table.Body = TableBody;
Table.Footer = TableFooter;
Table.Row = TableRow;
Table.HeaderCell = TableHeaderCell;
Table.Cell = TableCell;

export default Table;
